module.exports = __webpack_public_path__ + "img/shop-container-bg.b9dc29d2.webp";